<template>
  <div class="text-center my-5">
    <h3>Coming Soon.</h3>
    <h5>We are currently working hard to bring this feature to you. Stay tuned!</h5>
  </div>
</template>
<script>
import video from './partials/Video';
import moment from 'moment';
import Calendar from 'v-calendar/lib/components/calendar.umd';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import ShiurimCard from './partials/ShiurimCard';
import LiveThumbnail from './live/LiveThumbnail';
import LiveThumbnailMobile from './live/LiveThumbnailMobile';
import { toPng } from 'dom-to-image';

export default {
  components: {
    jwvideo: video,
    Calendar,
    ShiurimCard,
    LiveThumbnail,
    LiveThumbnailMobile,
  },
  i18nOptions: {
    namespaces: 'pages',
    keyPrefix: 'live',
  },

  data: () => {
    return {
      liveVideos: [],
      archive: [],
      filteredArchive: [],
      upcoming: [],

      selectedUpcomingDate: null,
      selectedRecordingDate: null,

      calendar: {
        // attrs: [{ key: 'selected', highlight: { color: 'blue' } }],
        attrs: [],
        recAttr: [],
      },
    };
  },
  metaInfo: function () {
    return { title: 'Live' };
  },
  mounted: function () {
    this.loadLiveSessions();
    this.showEnteriesOnCalendar();
  },

  methods: {
    loadLiveSessions() {
      this.$http.get('/api/live').then(response => {
        this.liveVideos.splice(0);
        response.data.forEach(s => this.liveVideos.push(s));
      });
    },
    loadUpcomingSessions(date) {
      this.selectedUpcomingDate = moment(date).format('MMMM Do YYYY');
      let start_date = moment(date.id || date)
        .utc()
        .format('YYYY-MM-DD HH:mm:ss');

      let end_date = moment(date.id || date)
        .add(1, 'day')
        .utc()
        .format('YYYY-MM-DD HH:mm:ss');

      this.$http.get('/api/live/upcoming?start_date=' + start_date + '&end_date=' + end_date).then(response => {
        this.upcoming.splice(0);
        response.data.forEach(stream => {
          stream.timing = this.getTiming(stream.start);
          this.upcoming.push(stream);
        });
      });
    },
    loadRecordings(date) {
      this.selectedRecordingDate = moment(date).format('MMMM Do YYYY');
      let start_date = moment(date.id || date)
        .utc()
        .format('YYYY-MM-DD HH:mm:ss');

      let end_date = moment(date.id || date)
        .add(1, 'day')
        .utc()
        .format('YYYY-MM-DD HH:mm:ss');

      this.$http.get('/api/recordings?start_date=' + start_date + '&end_date=' + end_date).then(response => {
        this.archive.splice(0);
        response.data.forEach(r => {
          r.timing = this.getTiming(r.created_at);
          r.topic = r.shiur.topic;
          r.image = r.shiur.speaker.image;
          this.archive.push(r);
        });
      });
    },
    getTiming(start) {
      return moment.utc(start).local().format('MMMM Do YYYY, h:mma');
    },
    visitMeeting(video) {
      let url = (video.type === 'meeting' ? '/live/' : '/live-stream/') + video.id;
      if (video.occurrence_id) {
        url += '?occurrence=' + video.occurrence_id;
      }
      this.$router.push(url);
    },
    minutesOfDay: function (m) {
      m = m || moment();
      return m.minutes() + m.hours() * 60;
    },
    showEnteriesOnCalendar() {
      this.$http.get('/api/live/dates').then(resp => {
        this.calendar.attrs.push(this.getCalendarDates(resp.data.upcoming));
        this.calendar.recAttr.push(this.getCalendarDates(resp.data.recordings));

        let today = moment().startOf('day').format('YYYY-MM-DD');

        this.loadUpcomingSessions(today);
        this.loadRecordings(today);
      });
    },
    getCalendarDates(dates) {
      return {
        key: 'live',
        highlight: {
          color: 'blue',
          fillMode: 'none',
        },
        dates: dates.map(session => moment.utc(session).local().toDate()),
      };
    },
    /*downloadThumbnailDesktop(video) {
      video.loadingThumbnailDownload = true;
      let node = document.getElementById('live-thumbnail-container-' + video.id);
      let title =
        video.title +
        ' by ' +
        video.speaker.name +
        ' on ' +
        moment()
          .utc(video.start)
          .local()
          .format('MMM DD hh-mm A');
      this.downloadThumbnail(node, title);
    },*/
    downloadThumbnailMobile(video) {
      let node = document.getElementById('live-thumbnail-mobile-container-' + video.id);
      let title = video.title + ' by ' + video.speaker.name + ' on ' + moment().utc(video.start).local().format('MMM DD hh-mm A');

      if (video.attachment) {
        this.downloadFromUrl(video.attachment.url, title);
        return;
      }
      node.parentElement.style.display = 'block';

      this.$set(video, 'loadingThumbnailDownload', true);
      let options = {
        style: {
          left: '0',
          right: '0',
          bottom: '0',
          top: '0',
        },
      };
      this.downloadThumbnail(node, title, video, options).then(() => {
        node.style.left = '-999999px';
        node.parentElement.style.display = 'none';
      });
    },
    downloadThumbnail(node, title, video, options = {}) {
      return new Promise(resolve => {
        options.cacheBust = true;
        toPng(node, options)
          .then(dataUrl => {
            console.log(node, node.style.left);
            this.downloadFromUrl(dataUrl, title, video);
            resolve();
          })
          .catch(function (error) {
            console.error('oops, something went wrong!', error);
          });
      });
    },
    downloadFromUrl(dataUrl, title, video = null) {
      let link = document.createElement('a');
      link.download = title;
      link.href = dataUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      if (video) {
        video.loadingThumbnailDownload = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.max-height-responsive {
  max-height: 500px;
}
.custom-border {
  border: solid 1px #c2c0c0;
}
</style>

<style>
.live-page .vc-day-content:focus {
  background-color: #2a5b8f !important;
  color: white !important;
}
</style>
